jQuery(function($)
{
    var
        classActive = 'active',
        { showExclusive } = orion,
        $container = $('body');

    if (0 === $('.js-tabs').length)
    {
        return;
    }

    function openTab(targetId)
    {
        var $target = $('.tabbed-content > ' + targetId);

        if (1 !== $target.length)
        {
            return;
        }

        showExclusive($target, $target.siblings('.tab'));

        $('.js-tabs').trigger(orion.constants.EventTabOpened);

        $target
            .closest('.tabbed-content')
            .siblings('.nav')
            .find('a')
            .removeClass(classActive)
            .end()
            .find('a[href$="' + targetId + '"]')
            .addClass(classActive)
            .end();
    }

    function handleClick(e)
    {
        var
            $this = $(this),
            targetId = $this.attr('href');

        openTab(targetId);

        e.preventDefault();
    }

    function initialize()
    {
        if (window.location.hash)
        {
            $('.js-tabs').each(function()
            {
                $(this).find('a.active').
                    removeClass(classActive);
                $(this).find('a[href$="' + window.location.hash + '"]').
                    addClass(classActive);
            });
            window.location.hash = '';
        }
        $('.js-tabs').each(function()
        {
            openTab($(this).find('a.active')
                .attr('href'));
        });
    }

    initialize();
    $container.on('click', '.tabs a, a.tab-trigger', handleClick);
});
